import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '@/api/client';

export interface SubstituteTarget {
  id: string;
  name: string;
  composition?: string | null;
  stock: number;
}

export interface SubstituteEntry {
  id: string;
  name: string;
  shortName?: string | null;
  composition?: string | null;
  price: number;
  stock: number;
  unit: string;
  gstRate: number;
  /** "manual" when admin-linked, "auto" when matched on composition. */
  source: 'manual' | 'auto';
}

export interface SubstitutesResponse {
  target: SubstituteTarget;
  data: SubstituteEntry[];
}

export function useSubstitutes(medicineId: string | undefined) {
  return useQuery({
    queryKey: ['medicines', 'substitutes', medicineId],
    queryFn: () => api.get<SubstitutesResponse>(`/api/medicines/${medicineId}/substitutes`),
    enabled: Boolean(medicineId),
  });
}

export function useUpdateSubstitutes() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, substitutes }: { id: string; substitutes: string[] }) =>
      api.put<void>(`/api/medicines/${id}/substitutes`, { substitutes }),
    onSuccess: (_, { id }) =>
      void queryClient.invalidateQueries({ queryKey: ['medicines', 'substitutes', id] }),
  });
}
